// extracted by mini-css-extract-plugin
export default {"slate-gray":"#708090","slateGray":"#708090"};